// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeadingPDFcert,.coursenamePDFcert{
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-family: cursive;
}
.HeadingPDFcert{
    font-size: 7vh;
}

.StudentDetails
{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.StudentTable {
    width: 40%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  .StudentTable th, .StudentTable td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  .StudentTable th {
    background-color: #f2f2f2;
  }`, "",{"version":3,"sources":["webpack://./src/MyComponents/CertificateGeneration/CreateCertificate.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".HeadingPDFcert,.coursenamePDFcert{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-family: cursive;\n}\n.HeadingPDFcert{\n    font-size: 7vh;\n}\n\n.StudentDetails\n{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n.StudentTable {\n    width: 40%;\n    border-collapse: collapse;\n    margin-top: 20px;\n  }\n  \n  .StudentTable th, .StudentTable td {\n    padding: 10px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  .StudentTable th {\n    background-color: #f2f2f2;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
